import { Row, Col, Panel, Content, Navbar, DateRangePicker, IconButton, Grid } from "rsuite"
import SettingIcon from '@rsuite/icons/Setting';
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AnalyticList from "./analyticsTable";

export default function View() {
    const { key } = useParams();

    return (
        <div style={{ height: "100vh"}}>
            <AnalyticList key={key}/>
        </div>
    )
}